// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Interaction.proto" (package "alive", syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { SpeechRecognitionResult } from "./Audio";
import { Any } from "../../google/protobuf/any";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf enum alive.SystemMessage.MessageType
 */
export var SystemMessage_MessageType;
(function (SystemMessage_MessageType) {
    /**
     * @generated from protobuf enum value: TextOnly = 0;
     */
    SystemMessage_MessageType[SystemMessage_MessageType["TextOnly"] = 0] = "TextOnly";
    /**
     * @generated from protobuf enum value: Image = 1;
     */
    SystemMessage_MessageType[SystemMessage_MessageType["Image"] = 1] = "Image";
    /**
     * @generated from protobuf enum value: Progress = 2;
     */
    SystemMessage_MessageType[SystemMessage_MessageType["Progress"] = 2] = "Progress";
})(SystemMessage_MessageType || (SystemMessage_MessageType = {}));
/**
 * An icon that appears in the upper left of the message
 *
 * @generated from protobuf enum alive.SystemMessage.IconType
 */
export var SystemMessage_IconType;
(function (SystemMessage_IconType) {
    /**
     * @generated from protobuf enum value: NoIcon = 0;
     */
    SystemMessage_IconType[SystemMessage_IconType["NoIcon"] = 0] = "NoIcon";
    /**
     * @generated from protobuf enum value: Warning = 1;
     */
    SystemMessage_IconType[SystemMessage_IconType["Warning"] = 1] = "Warning";
    /**
     * @generated from protobuf enum value: Check = 2;
     */
    SystemMessage_IconType[SystemMessage_IconType["Check"] = 2] = "Check";
    /**
     * @generated from protobuf enum value: Star = 3;
     */
    SystemMessage_IconType[SystemMessage_IconType["Star"] = 3] = "Star";
})(SystemMessage_IconType || (SystemMessage_IconType = {}));
/**
 * @generated from protobuf enum alive.IntentStatus
 */
export var IntentStatus;
(function (IntentStatus) {
    /**
     * @generated from protobuf enum value: Idle = 0;
     */
    IntentStatus[IntentStatus["Idle"] = 0] = "Idle";
    /**
     * @generated from protobuf enum value: Assigned = 1;
     */
    IntentStatus[IntentStatus["Assigned"] = 1] = "Assigned";
    /**
     * @generated from protobuf enum value: Started = 2;
     */
    IntentStatus[IntentStatus["Started"] = 2] = "Started";
    /**
     * @generated from protobuf enum value: Canceled = 3;
     */
    IntentStatus[IntentStatus["Canceled"] = 3] = "Canceled";
    /**
     * @generated from protobuf enum value: Completed = 4;
     */
    IntentStatus[IntentStatus["Completed"] = 4] = "Completed";
})(IntentStatus || (IntentStatus = {}));
/**
 * @generated from protobuf enum alive.IntentPriority
 */
export var IntentPriority;
(function (IntentPriority) {
    /**
     * @generated from protobuf enum value: Default = 0;
     */
    IntentPriority[IntentPriority["Default"] = 0] = "Default";
    /**
     * @generated from protobuf enum value: Filler = 1;
     */
    IntentPriority[IntentPriority["Filler"] = 1] = "Filler";
    /**
     * @generated from protobuf enum value: Task = 2;
     */
    IntentPriority[IntentPriority["Task"] = 2] = "Task";
    /**
     * @generated from protobuf enum value: SmallTalk = 3;
     */
    IntentPriority[IntentPriority["SmallTalk"] = 3] = "SmallTalk";
    /**
     * @generated from protobuf enum value: TimeSensitive = 4;
     */
    IntentPriority[IntentPriority["TimeSensitive"] = 4] = "TimeSensitive";
    /**
     * @generated from protobuf enum value: Engagement = 5;
     */
    IntentPriority[IntentPriority["Engagement"] = 5] = "Engagement";
})(IntentPriority || (IntentPriority = {}));
/**
 * @generated from protobuf enum alive.SpeakerType
 */
export var SpeakerType;
(function (SpeakerType) {
    /**
     * @generated from protobuf enum value: Unspecified = 0;
     */
    SpeakerType[SpeakerType["Unspecified"] = 0] = "Unspecified";
    /**
     * @generated from protobuf enum value: Agent = 1;
     */
    SpeakerType[SpeakerType["Agent"] = 1] = "Agent";
    /**
     * Known registered user
     *
     * @generated from protobuf enum value: User = 2;
     */
    SpeakerType[SpeakerType["User"] = 2] = "User";
    /**
     * Uses track_id
     *
     * @generated from protobuf enum value: Unknown_Person = 3;
     */
    SpeakerType[SpeakerType["Unknown_Person"] = 3] = "Unknown_Person";
})(SpeakerType || (SpeakerType = {}));
/**
 * @generated from protobuf enum alive.InputModality
 */
export var InputModality;
(function (InputModality) {
    /**
     * @generated from protobuf enum value: UnspecifiedInputModality = 0;
     */
    InputModality[InputModality["UnspecifiedInputModality"] = 0] = "UnspecifiedInputModality";
    /**
     * @generated from protobuf enum value: Spoken = 1;
     */
    InputModality[InputModality["Spoken"] = 1] = "Spoken";
    /**
     * @generated from protobuf enum value: Typed = 2;
     */
    InputModality[InputModality["Typed"] = 2] = "Typed";
    /**
     * @generated from protobuf enum value: Select = 3;
     */
    InputModality[InputModality["Select"] = 3] = "Select";
})(InputModality || (InputModality = {}));
// @generated message type with reflection information, may provide speed optimized methods
class Intent$Type extends MessageType {
    constructor() {
        super("alive.Intent", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "intent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "intent_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "priority", kind: "enum", T: () => ["alive.IntentPriority", IntentPriority] },
            { no: 5, name: "transition_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "speaker_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "addressee_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "speaker_type", kind: "enum", T: () => ["alive.SpeakerType", SpeakerType] },
            { no: 9, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "focus_object_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "gesture_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "user_input", kind: "message", T: () => UserInput },
            { no: 13, name: "previous_intent", kind: "message", T: () => Intent },
            { no: 14, name: "data", kind: "message", T: () => Any },
            { no: 15, name: "deadline", kind: "message", T: () => Timestamp },
            { no: 16, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "user_response_options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserResponseOption },
            { no: 18, name: "topics", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "ignorePresence", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "extended_turn", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "notification_surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "next_response_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.Intent
 */
export const Intent = new Intent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserInput$Type extends MessageType {
    constructor() {
        super("alive.UserInput", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "input_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "input_modality", kind: "enum", T: () => ["alive.InputModality", InputModality] },
            { no: 6, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_final", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "option", kind: "message", T: () => UserResponseOption },
            { no: 9, name: "speech_recognition_result", kind: "message", T: () => SpeechRecognitionResult }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.UserInput
 */
export const UserInput = new UserInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserResponseOption$Type extends MessageType {
    constructor() {
        super("alive.UserResponseOption", [
            { no: 1, name: "response_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "icon_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "rgb_hex_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "prev_intent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.UserResponseOption
 */
export const UserResponseOption = new UserResponseOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemMessage$Type extends MessageType {
    constructor() {
        super("alive.SystemMessage", [
            { no: 1, name: "messageUid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "messageType", kind: "enum", T: () => ["alive.SystemMessage.MessageType", SystemMessage_MessageType] },
            { no: 4, name: "addressee_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "iconType", kind: "enum", T: () => ["alive.SystemMessage.IconType", SystemMessage_IconType] },
            { no: 6, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "durationMs", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "imagePath", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "imageLabel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "progress", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "data", kind: "message", T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SystemMessage
 */
export const SystemMessage = new SystemMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextSnippet$Type extends MessageType {
    constructor() {
        super("alive.TextSnippet", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "emphasized", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "imagePath", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.TextSnippet
 */
export const TextSnippet = new TextSnippet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Notification$Type extends MessageType {
    constructor() {
        super("alive.Notification", [
            { no: 1, name: "notificationUid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "imageUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "jsonData", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.Notification
 */
export const Notification = new Notification$Type();
/**
 * @generated ServiceType for protobuf service alive.FakeServiceInteraction
 */
export const FakeServiceInteraction = new ServiceType("alive.FakeServiceInteraction", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
